import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core'
import { FileService } from '../../services/file.service'

@Component({
    selector: 'app-file-input',
    templateUrl: './file-input.component.html',
    standalone: false
})
export class FileInputComponent {
  constructor(private fileService: FileService) {}

  @ViewChild('fileInputControl', { static: true }) fileInput: any;

  @Output() getFile = new EventEmitter<File>();
  @Output() getFiles = new EventEmitter<Array<File>>();
  // TODO: Add validator
  @Input() validExtensions: string[];
  @Input() maxSizeMb: number;
  @Input() selectMultiple: boolean = false;
  private files: Array<File> = [];

  onChange(event: FileList): void {
    var errors = null
    this.uploadFiles(event)
    if (!this.selectMultiple) {     
      errors = this.fileService.validateExtensionsAndMaximumAllowedSize(
        this.files[0],
        this.validExtensions,
        this.maxSizeMb
      )
    }
    if (errors) {
      this.files = []
    } else {
      this.getFile.next(this.files[0])
      this.getFiles.next(this.files)
    }
  }
  uploadFiles(event: FileList): void {
    if (event[0] != null) {
      this.files = []
      for (let i = 0; i < event.length; i++) {
        this.files.push(event[i])
      }
    }
  }
  selectFile(): void {
    this.fileInput.nativeElement.value = null
    this.fileInput.nativeElement.click()
  }
}
